module.exports = __webpack_public_path__ + "media/images/yakkyoku_guide_thumb-49cd4cdc1c4e746405e41a920ca76703.png";